import { memo, ReactNode } from "react";
import { cn } from "../../utils/cn";
import IconBadge from "../badges/IconBadge";

interface LiveEvacuationDashboardCardProps {
  data: {
    id: number;
    key: number;
    title: string;
    count: number;
    bgColor: string;
    icon: ReactNode;
  };
}

const LiveEvacuationDashboardCard = ({ data }: LiveEvacuationDashboardCardProps) => {
  const { title, count, bgColor, icon } = data;

  return (
    <div
      className={cn(
        "flex flex-col text-white px-5 py-4 xl:p-3 rounded-[15px] gap-1",
        bgColor,
      )}
    >
      <div className="flex items-center justify-between">
        <h1 className="text-white font-light text-3xl">{count}</h1>

        <IconBadge icon={icon} styles='border border-white' />
      </div>

      <div className="flex flex-col gap-[2px]">
        <h1 className="text-white">{title}</h1>
      </div>
    </div>
  );
};

export default memo(LiveEvacuationDashboardCard);
